//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapGetters } from 'vuex';

export default {
  name: 'SubscribePricesReseller',
  computed: {
    ...mapState({
      reseller: state => state.user.member.resellerDetails,
    }),
    ...mapGetters({
      getPlanBilledYearly: 'subscription/getPlanBilledYearly',
    }),
    resellerName() {
      return _.get(this.reseller, 'name') || this.$i18n.t('term.reseller');
    },
  },
  methods: {
    onClickContactReseller() {
      this.$store.dispatch('modal/show', {
        component: () => ({
          component: import('@motionelements/core/src/components/modals/ContactReseller.vue'),
        }),
      });
    },
  },
};
